module.exports = __webpack_public_path__ + "img/主题.af4129ad.png";